const accountingBases = (["cash", "accrual"] as const).map((e) => e);
export type AccountingBases = (typeof accountingBases)[0];

export class AccountingBasis {
  constructor({ name }: { name: AccountingBases }) {
    this.name = name;
  }

  name: AccountingBases;

  static def: AccountingBasis = new AccountingBasis({ name: "cash" });

  static fromString(str: string): AccountingBasis {
    const lowerStr = str.replace(/[_-]/g, "").toLowerCase();
    const name = accountingBases.find((e) => e.toLowerCase() === lowerStr);
    if (name) {
      return new AccountingBasis({ name });
    }
    throw new Error("Invalid type of the accounting basis.");
  }

  static isValidString(str?: string): boolean {
    const lowerStr = str?.replace(/[_-]/g, "")?.toLowerCase();
    const name = accountingBases.find((e) => e.toLowerCase() === lowerStr);
    return !!name;
  }

  toString(): string {
    return this.name;
  }
}
